/**
 * Case Field Value Display Entity
 * Represents a field value with display metadata from the API response.
 * Used for readonly display mode - includes label directly from API.
 *
 * This entity captures the rich API response from /field-values endpoint,
 * avoiding the need for a separate field-definitions API call.
 */
export class CaseFieldValueDisplayEntity {
  public id!: string;
  public versionFieldId!: string;
  public fieldLabel!: string;
  public fieldType!: string;
  public value!: string | null;
  public isRequired!: boolean;
  public isVisibleToRequester!: boolean;
  public sortOrder!: number;
  public optionsJson?: string | null;
}
